//ANGULAR
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
//COMPONENTS
import { SharedComponent } from './shared.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ConditionsComponent } from './components/conditions/conditions.component';
import { IeComponent } from './components/ie/ie.component';
import {DialogModule} from 'primeng/dialog';
import { PaymentComponent } from './components/payment/payment.component';
import { ButtonModule } from 'primeng/button';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule
  ],
  declarations: [
    SharedComponent,
    NotFoundComponent,
    ConditionsComponent,
    IeComponent,
    PaymentComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    NotFoundComponent,
    ConditionsComponent,
    IeComponent
  ]
})
export class SharedModule {
}
